// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-unknown"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10.5V7L15 2H4V22H13.5M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.5 16.2489C15.5 15.0069 16.6193 14 18 14C19.3807 14 20.5 15.0069 20.5 16.2489C20.5 16.8593 20.2296 17.413 19.7907 17.8182L18 19.5073V19.6223M17.999 22.9961H18.0029V23H17.999V22.9961Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileUnknownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-unknown',
    ref,
    icon: element,
  },
));

FileUnknownIcon.displayName = 'FileUnknownIcon';

export default FileUnknownIcon;
